import "regenerator-runtime/runtime";
import $ from "jquery";
import FormatInterface from './FormatInterface';
import {brandings} from "../../general-handlers";

export default class BrandingDesktopFormat extends FormatInterface {
    async render() {
        return await this.getTemplate();
    }

    callback() {
        const parent = $('a.branding').parents('.banner-wrapper--not-for-mobile');
        const element = $('a.branding');

        if (element.parent().is('div[id^="BrandingDesktopFormat"]')) {
            element.attr('id', element.parent().attr('id'))
        }

        element.appendTo(parent);

        parent.find('div.branding').remove();

        brandings(true);
    }

    getTemplate() {
        const data = $('.banner-wrapper--not-for-mobile div.branding .ad-content').data();
        let stringData = '';

        for (const key in data) {
            stringData += ` data-${key}="${data[key]}" `;
        }

        return `<a href="${this.params.link}"  target="_blank" class="banner banner--size-8 branding">
                    <div class="ad-content__wrapper">
                        <div class="ad-content" ${stringData}
                             style="width:100%; 
                                    height: ${this.params.container.height}px; 
                                    background-repeat: no-repeat; 
                                    background: url(${this.params.imgUrl}); 
                                    background-repeat-y: no-repeat; 
                                    background-color:${this.params.color !== undefined ? this.params.color : 'transparent'}; 
                                    background-position: center top">                             
                        </div>
                    </div>    
                </a>`;
    }
}
